import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';

import type { GetPaymentIntentResponse } from './types';

async function fetchPaymentIntent(exclude?: string[]) {
  const params = exclude?.length ? { exclude: exclude.join(',') } : undefined;
  const response = await apiClient.get<GetPaymentIntentResponse>(
    '/v1/payment/setup-intent',
    { params },
  );
  return response.data;
}

export const getPaymentIntentQuery = (exclude?: string[]) =>
  queryOptions({
    queryKey: ['payment-intent', ...(exclude ?? [])],
    queryFn: () => fetchPaymentIntent(exclude),
    retry: 2,
  });
